export default __webpack_public_path__ + "static/media/resposta_certa_01.e551a94d.mp3";